import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getAllLocations } from '../data/locations';
import { MapPin, ArrowRight } from 'lucide-react';

const LocationsSection = () => {
  const { t } = useLanguage();
  const locations = getAllLocations();

  return (
    <section id="locations" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-[#8B1C1C] font-semibold text-sm uppercase tracking-wider mb-4">
            {t('Our Studios', 'Studio Kami')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e1919] mb-6">
            {t('Locations Worldwide', 'Lokasi di Seluruh Dunia')}
          </h2>
          <p className="text-[#736c64] text-lg max-w-2xl mx-auto">
            {t(
              'Studio Ballet Izora brings world-class ballet education to young dancers across Asia and Africa.',
              'Studio Ballet Izora membawa pendidikan balet kelas dunia kepada penari muda di seluruh Asia dan Afrika.'
            )}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {locations.map((location) => (
            <Link
              key={location.id}
              to={location.slug === 'surabaya' ? '/' : `/standorte/${location.slug}`}
              className="group bg-[#f7f5f2] rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={location.images.hero}
                  alt={`Studio Ballet Izora ${location.city}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white">{location.city}</h3>
                  <p className="text-white/80 text-sm">{location.country}</p>
                </div>
                {location.slug === 'surabaya' && (
                  <div className="absolute top-4 right-4 bg-[#8B1C1C] text-white text-xs px-3 py-1 rounded-full font-semibold">
                    {t('Main Studio', 'Studio Utama')}
                  </div>
                )}
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-2 text-[#736c64] mb-4">
                  <MapPin className="w-4 h-4" />
                  <span className="text-sm">{location.schoolInfo.location}</span>
                </div>
                
                <p className="text-[#736c64] text-sm mb-4 line-clamp-2">
                  {t(location.schoolInfo.descriptionEn, location.schoolInfo.descriptionId).substring(0, 100)}...
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="text-sm">
                    <span className="font-semibold text-[#1e1919]">{location.schoolInfo.studentsCount}</span>
                    <span className="text-[#736c64] ml-1">{t('Students', 'Siswa')}</span>
                  </div>
                  <span className="text-[#8B1C1C] font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                    {location.slug === 'surabaya' 
                      ? t('You are here', 'Anda di sini')
                      : t('Visit Studio', 'Kunjungi Studio')
                    }
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
